import { useState } from 'react'
import { ContentModal } from 'components/organisms/modals/content-modal'

interface DownloadAppModalProps {
	open: boolean
	setOpen: (open: boolean) => void
	onContinue: () => void
}

export function DownloadAppModal({ open, setOpen, onContinue }: DownloadAppModalProps) {
	return (
		<ContentModal open={open} setOpen={setOpen} size={'sm'} isModal hideCloseButton>
			<div>
				<div className="p-0">
					<h3 className="text-2xl font-medium mb-6 flex justify-center items-center gap-2">
						Download Loyalink on App Store
					</h3>
				</div>
				<div className="mt-2 max-w-xs mx-auto">
					<div className="space-y-5 text-center">
						<div className="flex justify-center items-center">
							<a
								onClick={() => setOpen(false)}
								href="https://apps.apple.com/us/app/id1623230623"
								target="_blank"
								className="focus-visible:outline-none"
							>
								<img
									className="w-40"
									src="https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg"
									alt="https://apps.apple.com/us/app/id1623230623"
								/>
							</a>
						</div>
						<button
							type="button"
							onClick={onContinue}
							className="w-full h-12 rounded-full flex justify-center items-center transition-all duration-300 bg-primary text-white font-bold hover:bg-primary-hover disabled:bg-white-25 disabled:text-white-25 disabled:backdrop-blur-lg outline-none"
						>
							Continue on this browser
						</button>
					</div>
				</div>
			</div>
		</ContentModal>
	)
}

// ---------------------------------------------------------------------------
// Modal Manager integration
// ---------------------------------------------------------------------------

export interface DownloadAppModalManagedProps {
	onContinue: () => void
}

declare module 'components/organisms/modals/modal-registry' {
	interface ModalRegistry {
		'download-app': DownloadAppModalManagedProps
	}
}

export function ManagedDownloadAppModal({
	onClose,
	onContinue,
}: DownloadAppModalManagedProps & { onClose: () => void }) {
	const [open, setOpen] = useState(true)

	const handleClose = () => {
		setOpen(false)
		setTimeout(onClose, 200)
	}

	return (
		<DownloadAppModal
			open={open}
			setOpen={(v: boolean) => { if (!v) handleClose() }}
			onContinue={() => { onContinue(); handleClose() }}
		/>
	)
}
